import actions from "./actions";

const {
  SET_DATA_WAREHOUSES,
  GET_DATA_BEGIN_WAREHOUSES,
  GET_DATA_FINISH_WAREHOUSES,
  SET_DATA_INVENTORIES,
  GET_DATA_BEGIN_INVENTORIES,
  GET_DATA_FINISH_INVENTORIES,
  SET_DATA_PRODUCTS_BY_WAREHOUSE,
  GET_DATA_BEGIN_PRODUCTS_BY_WAREHOUSE,
  GET_DATA_FINISH_PRODUCTS_BY_WAREHOUSE
} = actions;

const initialState = {
  warehouses: [],
  inventories: [],
  warehousesLoading: false,
  inventoriesLoading: false,
  totalItems: 0,
  currentPage: 1,
};

const warehousesReducer = (state = initialState, action: any) => {
  const { type, data } = action;
  switch (type) {
    case GET_DATA_BEGIN_WAREHOUSES:
      return { 
        ...state, 
        warehousesLoading: true 
    };
    case SET_DATA_WAREHOUSES:
      return { 
        ...state, 
        warehouses: data || [], warehousesLoading: false 
    };
    case GET_DATA_FINISH_WAREHOUSES:
      return { 
        ...state, 
        warehousesLoading: false 
    };

    case GET_DATA_BEGIN_INVENTORIES:
      return { 
        ...state, 
        inventoriesLoading: true 
    };
    case SET_DATA_INVENTORIES:
      return {
        ...state,
        inventories: Array.isArray(data?.list) ? data.list : [],
        totalItems: data?.totalItems || 0,
        currentPage: data?.currentPage || 1,
        inventoriesLoading: false,
      };
    case GET_DATA_FINISH_INVENTORIES:
      return { 
        ...state, 
        inventoriesLoading: false 
    };
    case GET_DATA_BEGIN_PRODUCTS_BY_WAREHOUSE:
      return {
        ...state,
        inventoriesLoading: true
      };
    case SET_DATA_PRODUCTS_BY_WAREHOUSE:
      return {
        ...state,
        inventories: Array.isArray(data?.list) ? data.list : [],
        totalItems: data?.totalItems || 0,
        currentPage: data?.currentPage || 1,
        inventoriesLoading: false
      };
    case GET_DATA_FINISH_PRODUCTS_BY_WAREHOUSE:
      return {
        ...state,
        inventoriesLoading: false
      };

    default:
      return state;
  }
};

export { warehousesReducer };